import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
} from 'src/common/external/bambi-api/bambiApi';
import { formatPassengerFullName } from 'src/common/util/formatFullName';
import { formatSimpleTime } from 'src/features/dispatch/common/formatSimpleTime';

export function TripTitle({
  trip,
}: {
  trip: DispatchTripRead | RunBambiRunTripRead | RunBambiRunReassignedTripRead;
}) {
  return (
    <div className="flex flex-wrap gap-1">
      <div className="break-word text-xs font-bold">
        {formatPassengerFullName(trip.passenger)}
      </div>
      <div className="flex min-w-[100px] text-[.63rem]">
        <span data-testid="pickup-at">
          {formatSimpleTime(trip.scheduled_pickup_at)}
        </span>
        &nbsp;-&nbsp;
        <span data-testid="dropoff-at">
          {formatSimpleTime(trip.scheduled_dropoff_at)}
        </span>
        {trip.appointment_at && (
          <span data-testid="appointment-at">
            {` (${formatSimpleTime(trip.appointment_at)})`}
          </span>
        )}
      </div>
    </div>
  );
}
